import { render } from "./BaseCancelSave.vue?vue&type=template&id=3daa66ef&scoped=true"
import script from "./BaseCancelSave.vue?vue&type=script&lang=js"
export * from "./BaseCancelSave.vue?vue&type=script&lang=js"

import "./BaseCancelSave.vue?vue&type=style&index=0&id=3daa66ef&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3daa66ef"]])

export default __exports__